import script from "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KTopo/KTopoDesktop.vue?type=script"
export * from "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KTopo/KTopoDesktop.vue?type=script"
import { render } from "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KTopo/KTopoDesktop.vue?type=template"

script.render = render
export default script